@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';
@import (reference) '../settings-page.module.less';

.content-wrap {
  height: 100%;
}

.top-section {
  padding: @settings-page--tabbed--header--padding;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .left {
    display: initial;
  }
}

.description {
  line-height: 1.4em;
  margin: @space-8 0;
}

.inline-lightbulb {
  height: 12px;
  padding-right: @space-8;
  color: var(--primary--icon--fill-color--3);
}

.balance-container {
  width: 350px;
}

.messaging-inline {
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  gap: @space-8;

  width: 454px;
  height: 24px;

  /* Blues/blue-200 */
  background: #ebf5fa;

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;

  span {
    width: 422px;
    height: 15px;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    display: flex;
    align-items: center;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 1;
    a {
      padding-left: 0.2rem;
    }
  }
}

.banner {
  flex-wrap: nowrap;
}

.banner-content-wrapper {
  > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.banner-button {
  white-space: nowrap;
}

.tab-list {
  padding-left: @space-24;
}

.tab-content {
  gap: @space-32;
}

.disabled-text {
  color: @settings-page--popular--disabled--text-color;
  padding-left: 3px;
}

.selected-tab {
  background-color: @settings-page--tabbed--tab-panel--background-color;
}

.selected-tab-panel {
  padding: @settings-page--tabbed--tab-panel--padding;
  background-color: @settings-page--tabbed--tab-panel--background-color;
}
